import { LitComponent } from "./lit-component";

import type { PropertyDeclarations } from "lit";

export class QuantityInput extends LitComponent {
  static properties: PropertyDeclarations = {
    label: { type: String },
    max: { type: Number },
    value: { state: true },
  };

  value = 1;
  label = "";
  max = Infinity;

  get app() {
    if (!window.WishlistKing) {
      throw new Error("Wishlist King SDK not initialized");
    }
    return window.WishlistKing;
  }

  decrease() {
    this.value = Math.max(1, this.value - 1);
  }

  increase() {
    this.value = Math.min(this.max, this.value + 1);
  }

  render() {
    const inputId = `${this.app.utils.url.handlelize(this.id)}-input`;

    return this.lit.html`
      <div class="wk-quantity-input">
        <label class="wk-label" for=${inputId}>${this.label}</label>
        <div class="wk-control">
          <wk-button 
            .text=${"-"} 
            .showText=${true} 
            @click=${this.decrease}
          ></wk-button>
          <input
            id=${inputId}
            class="wk-input"
            type="number"
            name="quantity"
            value=${this.value}
            min="1"
          />
          <wk-button 
            .text=${"+"}
            .showText=${true}
            @click=${this.increase}
          ></wk-button>
        </div>
      </div>
    `;
  }

  createRenderRoot() {
    return this;
  }
}

if (!customElements.get("wk-quantity-input")) {
  customElements.define("wk-quantity-input", QuantityInput);
}

declare global {
  interface HTMLElementTagNameMap {
    "wk-quantity-input": QuantityInput;
  }
}
